import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { RECIPE_CATEGORIES } from './salesData';
import { RECIPES_IMAGE_URL } from '../utils/headMeta';
export function PositioningSection() {
  return <section id="recetas" className="bg-sand py-14 sm:py-20" data-id="element-265" data-mp="1032msgp34b59">
      <div className="mx-auto max-w-6xl px-5" data-id="element-266" data-mp="v62bnrddoi7a">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:items-center lg:gap-14" data-id="element-267" data-mp="v5ajyrmwj4ma">
          <div data-id="element-268" data-mp="q4d44lpd6mny">
            <SectionTag className="bg-white" data-id="element-269" data-mp="m4vvxkijzbf3">60 recetas comerciales</SectionTag>
            <h2 className="mt-4 max-w-[18ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2.4rem]" data-id="element-270" data-mp="m6yrsl6dzyrq">
              Recetas elegidas para <span className="text-gold" data-id="element-271" data-mp="c89aatiekgc0">vender</span>, no sólo para cocinar.
            </h2>
            <p className="mt-4 max-w-[48ch] font-sans text-[0.92rem] leading-relaxed text-taupe sm:text-[1rem]" data-id="element-272" data-mp="2bihjrkhan30d">
              La cantidad por sí sola no sirve de nada. Cada receta entró al libro porque facilita la
              producción, se conserva bien, resiste el traslado y se vende con buena presentación.
            </p>

            <ul className="mt-7 grid gap-2.5" data-id="element-273" data-mp="29e0pvknyitha">
              {RECIPE_CATEGORIES.map((cat, i) => <motion.li key={cat.title} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.28,
              ease: [0.23, 1, 0.32, 1],
              delay: Math.min(i, 4) * 0.04
            }} className="flex gap-3 rounded-2xl bg-white p-4 shadow-[0_10px_28px_-24px_rgba(56,37,34,0.5)]" data-id="element-274" data-mp="1viot77q8qsxq" data-mpi={i}>
                  <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gold" aria-hidden data-id="element-275" data-mp="373ltbstpucwc" />
                  <div data-id="element-276" data-mp="3bv3scbc6i3eo">
                    <h3 className="font-display text-[0.92rem] font-bold tracking-tight text-charcoal" data-id="element-277" data-mp="3bvdm8a0cgupn">
                      {cat.title}
                    </h3>
                    <p className="mt-1 max-w-[52ch] font-sans text-[0.84rem] leading-relaxed text-taupe" data-id="element-278" data-mp="3grr79vdadgaw">
                      {cat.desc}
                    </p>
                  </div>
                </motion.li>)}
            </ul>
          </div>

          <img src={RECIPES_IMAGE_URL} alt="Brownies, alfajores, cookies, budines, cheesecake y postres en vaso con frutos rojos" loading="lazy" decoding="async" width={1200} height={800} className="h-full w-full rounded-3xl object-cover shadow-[0_30px_60px_-34px_rgba(56,37,34,0.55)]" data-id="element-279" data-mp="37svyqcmrru4f" />
        </div>
      </div>
    </section>;
}